module.exports = __webpack_public_path__ + "img/wu.315ed270.png";